<template>
  <page-view title="专家列表">
    <template slot="action" v-if="IsExpertInfoAdmin()">
      <a-space>
        <a-button @click="openExpertAdd" icon="save" type="primary">
          添加专家
        </a-button>
        <a-popconfirm title="该设置的方式会覆盖已设置的标签！，请谨慎操作" ok-text="确认" cancel-text="取消"
                      @confirm="batchSetTag">
          <a-button icon="book" type="primary">一键设置标签</a-button>
        </a-popconfirm>
        <a-button v-if="false " @click="expertImportVisible = true" icon="file-excel" type="primary">
          excel导入
        </a-button>
        <expert-upload-selector v-if="false" url="/zj/api/1/expertmain/expertInfo/upload" :max="1"
                                @success="uploadSuccess"></expert-upload-selector>
        <expert-tem v-if="false" filepath="conf/epp/expert/expertInfoImport_template.xlsx" filename="专家导入模板.xlsx"
                    title="模板导出"/>
        <a-button  @click="$refs.expertSTable.exportInfo()" icon="file-excel" type="primary">导出专家信息</a-button>
      </a-space>
    </template>

    <expert-s-table :show-tag="$route.query.tag" ref="expertSTable" :from-type="ExpertFromType.EXPERT_LIST" @onSelectKey="onSelectKey"/>

    <expertImport-modal :visible="expertImportVisible" @success="expertImportVisible = false"
                        @cancel="expertImportVisible = false"/>
    <expert-add ref="expertAddRef" @success="$refs.expertSTable.ESTreFresh()"/>
  </page-view>
</template>

<script>
import { PageView } from '@/layouts'

import expertSTable from '@/epp/expertmain/expertInfo/common/ExpertSTable.vue'
import expertImportModal from '@/epp/expertmain/expertInfo/common/ExpertImportModal.vue'
import ExpertTem from '@/epp/expertmain/expertInfo/export/template/ExpertTem.vue'
import ExpertUploadSelector from '@/epp/expertmain/expertInfo/import/ExpertUploadSelector.vue'
import { ExpertFromType } from '@/epp/expertmain/expertInfo/utils/ExpertInfoUtil'
import TagSetModal from '@/epp/expertmain/experttag/modal/TagSetModal.vue'
import ExpertAdd from '@/epp/expertmain/expertInfo/ExpertAdd.vue'
import { IsExpertInfoAdmin } from '@/epp/expertmain/userperm/UserPermUtil'

export default {
  name: 'ExpertIndex',
  computed: {
    ExpertFromType () {
      return ExpertFromType
    },
  },
  components: {
    ExpertAdd,
    TagSetModal,
    PageView,
    expertSTable,
    expertImportModal,
    ExpertTem,
    ExpertUploadSelector
  },
  data () {
    return {
      user: this.$ls.get('user'),
      expertImportVisible: false,
      selectedRowKeys: [],
      IsExpertInfoAdmin
    }
  },
  created () {
  },
  methods: {
    openExpertAdd () {
      this.$refs.expertAddRef.loadData()
    },
    uploadSuccess (message) {
      this.$message.success(message)
      this.$refs.expertSTable.ESTrefresh()
    },
    batchSetTag () {
      if (this.selectedRowKeys.length === 0) {
        this.$message.error('请选择需要设置标签的专家！')
        return
      }
      this.$refs.expertSTable.onOpenTag({
        tagId: undefined,
        id: [...this.selectedRowKeys],
        emergencyFlag: undefined
      })
    },
    onSelectKey (keys) {
      this.selectedRowKeys = keys
    }
  }
}
</script>

<style lang="less" scoped>
.ant-calendar-picker {
  width: 47% !important;
}
</style>
